import React, { useMemo, useState } from 'react';
import { Box, Grid, Stack, Tooltip, Typography } from '@mui/material';
import useResourceHelper from '../../../../containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Reusable/ContentCards/useResourceHelper';
import '../../Shimmer/HelpandSupportShimmer/Shimmer.css';
interface CategoryItemProps {
  category: any;
  onSelect: (category: any) => void;
  onMouseEnter: (category: any) => void;
}

const CategoryItem: React.FC<CategoryItemProps> = ({
	category,
	onSelect,
	onMouseEnter
}) =>
{
	// Local state to track if the image has an error
	const [ hasImgError, setHasImgError ] = useState(false);
	const [ isImageLoaded, setIsImageLoaded ] = useState(false);
	const { getRandomBackgroundImage } = useResourceHelper();
	// Handle image load error
	const handleImageError = () =>
	{
		setHasImgError(true);
	};

	const handleImageLoad = () =>
	{
		setIsImageLoaded(true);
	};

	// Get the appropriate image source
	const getImageSrc = useMemo(() =>
	{
		if (hasImgError)
		{
			return getRandomBackgroundImage;
		}

		return category.image || category.thumbnailUrl || getRandomBackgroundImage;
	}, [ hasImgError, category ]);

	return (
		<Stack
			direction='row'
			spacing={1}
			alignItems='center'
			sx={{ padding: '10px', cursor: 'pointer', '&:hover': { backgroundColor: '#E3F2FD' }, width: '100%' }}
			onMouseEnter={() => onMouseEnter(category)}
			onClick={() => onSelect(category)}
		>
			<Box
				component='img'
				src={getImageSrc}
				onLoad={handleImageLoad}
				alt='Category'
				onError={handleImageError}
				sx={{ height: '35px', width: '54px', borderRadius: '6px', objectFit: 'contain' }}
				{...(!isImageLoaded && { className: 'shimmer' })}
			/>
			<Grid item minWidth={0} px={1}>
				<Tooltip title={category.title || category.name} arrow>
					<Typography
						fontSize='var(--pixel14)'
						color='var(--darkgray)'
						noWrap
						sx={{
							overflow     : 'hidden',
							textOverflow : 'ellipsis',
							whiteSpace   : 'nowrap',
							maxWidth     : '150px', // adjust as needed for your layout
							display      : 'block'
						}}
					>				{category.title || category.name}
					</Typography>
				</Tooltip>
			</Grid>
		</Stack>
	);
};

export default CategoryItem;